// extracted by mini-css-extract-plugin
module.exports = {"guideCardTitle":"styles_guideCardTitle__lHo23","guideCardTrailCount":"styles_guideCardTrailCount__aylX_"};